import { Fragment, ReactElement } from 'react';

import { palette } from '@lib/styles/palette';

import Icon from '@components/common/Icon';

import {
  ddCommon,
  emphasizeText,
  underLineText,
} from '../fraudSearchResult.style';

interface JnResultTextProps {
  result: {
    name: string;
    count: number;
    isOpen: boolean;
    openLocalDropdown: () => void;
  };
}

export default function LocalResultText({
  result: { name, count, isOpen, openLocalDropdown },
}: JnResultTextProps): ReactElement {
  return (
    <Fragment>
      <dt>{name}</dt>
      <dd css={ddCommon}>
        <p css={emphasizeText(count > 0)} className="result-text">
          신고 건수 {count > 0 ? `${count} 건` : '없음'}
        </p>
        {count > 0 ? (
          isOpen === false && (
            <button
              type="button"
              aria-label="viewDetail"
              onClick={openLocalDropdown}
            >
              <span>자세히보기</span>
              <Icon icon="arrowRight" size={17} />
            </button>
          )
        ) : (
          <p className="no-result-guide">
            &#40;신고 내역이 없는 경우에도{' '}
            <span css={emphasizeText(true)}>
              안전한 거래라는 것을 보장할 수 없습니다.
            </span>{' '}
            <span css={underLineText(palette.blue5)}>안전거래</span>를
            이용해주세요. &#41;
          </p>
        )}
      </dd>
    </Fragment>
  );
}
